export const MARKETS = [
    {
        id: 0,
        name: "Is Teff injera healthy?",
        image: '/assets/images/ingera-food.jpeg',
        featured: true,
        description: "Did you know that the star ingredient, teff, in injera, is not only super tasty but also jam-packed with nutrients? This grain is filled with complete proteins, fibre, magnesium, iron and calcium."
    }
]